import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import AppButton from '@/app/components/button/AppButton.vue'

import Layout from '../Layout.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Trial20710',
  props: {
    nextOnboardingPage: { type: Function }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Layout, { title: "Trial" }),
    _createVNode(AppButton, { onClick: __props.nextOnboardingPage }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode("Continue", -1)
      ]))]),
      _: 1
    }, 8, ["onClick"])
  ]))
}
}

})